import { ProductOrderDto } from "src/dtos/productOrder/ProductOrderDto";
import { getFutureWeekdayExceptTodayAndTomorrow } from "src/utils/date/dateUtils";
import { formatDate } from "src/utils/string/stringUtil";

export interface PRD2010_R01Dto extends ProductOrderDto {
    
    compNm: string;
    
    orderTypeNm: string;
    
    workplaceNm: string;
    
    jobTeamNm: string;
    
    itemNm: string;
    itemSpec: string;
    itemUnit: string;
    
    orderEmpNm: string;
	customCd: string;
	customNm: string;

	remark: string;

    codeEntity?: any | null;

    badQty: number;
    acceptQty: number;
    brandCd: string;
    brandNm: string;

    moreProcessTrigger: string;

	inserted: boolean,
	isModified: boolean,
	disabled: boolean,
}

/**
 * 생산 실적 관리의 단일 기본 데이터 (신규 행 추가시 사용)
 */
export const defaultPRD2010_R01Dto: PRD2010_R01Dto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

    productOrderNo:  '',
    compCd: '',
    compNm: '',
    // orderDt: getFutureWeekdayExceptTodayAndTomorrow(),
    orderDt: formatDate(new Date()),
    orderType: '',
    orderTypeNm: '',
    workplaceCd: '',
    workplaceNm: '',
    jobTeam: '',
    jobTeamNm: '',
    workProcess: '', // 누락된 속성 추가
    itemCd: '',
    itemNm: '',
    itemSpec: '',
    itemUnit: '',
    orderQty: 0,
    orderEmp: '',
    orderEmpNm: '',
    productPlanNo: '', // 누락된 속성 추가
    resultQty: 0,
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
    closeTag: "N",
	instructions: '',
    remark: '',
	
    codeEntity: null,
	
	customCd: '',
	customNm: '',

    badQty: 0,
    acceptQty: 0,
    brandCd: '',
    brandNm: '',

    moreProcessTrigger: '',

	inserted: false,
	isModified: false,
	disabled: false,
};
